import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-name"]
const _hoisted_2 = { class: "pf_label" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "pf_custom_toggle" }
const _hoisted_5 = {
  key: 2,
  class: "pf_error_text"
}
const _hoisted_6 = ["innerHTML"]

import ProductSelect from '@/components/product/ProductSelect.vue';
    import { PropType, ref, watch, onMounted } from 'vue'
    import { Attribute, Term } from '@/types/product';
    import { parseInchesToDecimal, validateWidth } from '@/services/custom-height-width';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'WidthSelect',
  props: {
        attribute: { type: Object as PropType<Attribute>, required: true },
        modelValue: { type: Object as PropType<Term | null>, required: false},
        productName: { type: String, required: true }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const widthSelection = ref<Term | undefined>()
    const useCustomWidth = ref<Boolean>(false)
    const customWidth = ref<String>('')
    const errorText = ref<String>('')

    function handleCustomWidthOnChange(event: Event) {
        verifyCustomWidth((event.target as any).value)
    }

    function verifyCustomWidth(input: string) {
        errorText.value = ''
        try {
            const parsedNum: number = parseInchesToDecimal(input)
            validateWidth(parsedNum, props.productName)

            const customTerm: Term = {
                id: 999999,
                name: input,
                slug: parsedNum.toString()
            }

            emits("update:modelValue",customTerm)

        } catch(err) {
            errorText.value = err as string
        }
    }

    function resetSelectedWidthWhileSwitching(goingToCustom: Boolean) {
        if(!goingToCustom) {
            errorText.value = ''
            if(widthSelection.value) {
                emits( "update:modelValue", widthSelection.value)
            }
        } else {
            if(customWidth.value) {
                verifyCustomWidth(customWidth.value as string)
            }
        }
    }

    function handleUseCustomClick() {
        useCustomWidth.value = !useCustomWidth.value
        resetSelectedWidthWhileSwitching(useCustomWidth.value)
    }


    watch(widthSelection, (current, old) => {
        emits("update:modelValue",current)
    })

    onMounted(() => {
        if(props.modelValue) {
            widthSelection.value = props.modelValue
            if(props.modelValue.id === 999999) {
                customWidth.value = props.modelValue.name
                useCustomWidth.value = true
            }
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!useCustomWidth.value)
      ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 0 }, props.attribute, {
          modelValue: widthSelection.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((widthSelection).value = $event))
        }), null, 16, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["pf_container", ['pf_'+props.attribute.name]]),
          "data-name": props.attribute.name,
          "data-type": "select"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", {
              for: 'pf_' + props.attribute.name
            }, _toDisplayString(props.attribute.label), 9, _hoisted_3)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["pf_input", {pf_error: errorText.value}])
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customWidth).value = $event)),
              type: "text",
              placeholder: "Custom Width (e.g. 26-1/16)",
              onChange: handleCustomWidthOnChange
            }, null, 544), [
              [_vModelText, customWidth.value]
            ])
          ], 2)
        ], 10, _hoisted_1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", { onClick: handleUseCustomClick }, "Click here to " + _toDisplayString(useCustomWidth.value ? 'choose a standard' : 'enter a custom') + " width", 1)
    ]),
    (errorText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", { innerHTML: errorText.value }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})